import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export const useDuplicateControlConfigSave = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const res = await $api.post('/v1/duplicate-control/config', data);

      return res.data;
    },
    onSuccess: data => {
      qc.invalidateQueries({ queryKey: [crmConstants.queryKeys.DUPLICATE_CONTROL_CONFIG] });
    }
  });
};
